import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { color } from './helpers/variables';
import { fontFamilyBody, hideOnPrint } from './helpers/mixins';

export const Button = styled.button`
  ${hideOnPrint};
  width: 100%;
  padding: 1rem 2rem;
  margin: 7px 0 20px;
  position: relative;

  color: ${color.white};
  background-color: ${color.black};
  border: 1px solid ${color.black};

  ${fontFamilyBody};
  font-size: 13px;
  text-align: center;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  overflow: hidden;

  cursor: pointer;
  transition: opacity 0.25s ease, background-color 150ms ease-out, border-color 150ms ease-out, color 150ms ease-out;

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: 0;
    border-color: ${color.black};
  }

  ${props =>
    props.success &&
    css`
      background-color: ${color.success};
      border-color: ${color.success};

      &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: ${color.success};
        background-image: url('/images/icons/checkmark.svg');
        background-repeat: no-repeat;
        background-size: 25px;
        background-position: center;
        transform: translateY(-100%);
        opacity: 0;
        transition: opacity 450ms ease-in-out, transform 250ms ease-in-out;
      }
    `}
  ${props =>
    props.buy &&
    css`
      margin: 0 0 15px;
      font-size: 15px;
      letter-spacing: 0.07em;
    `}
  ${props =>
    props.smallBuy &&
    css`
      width: auto;
      padding: 0.5rem 1rem;
      font-size: 10px;
      letter-spacing: 0.07em;
      &:after {
        background-size: 15px;
      }
    `}
    ${props =>
    props.sticky &&
    css`
      position: sticky;
      bottom: -1px;
      padding: 0.5rem 2rem;
    `};

  ${props =>
    props.active &&
    css`
      cursor: default;
      opacity: 1 !important;
      border-color: ${color.success};

      &:after {
        transform: translateY(0);
        opacity: 1;
      }
    `};
`;

Button.button = Button;
Button.a = Button.withComponent('a');
Button.link = Button.withComponent(Link);

Button.propTypes = {
  success: PropTypes.bool,
  sticky: PropTypes.bool,
  onClick: PropTypes.func
};

Button.link.propTypes = {
  success: PropTypes.bool,
  sticky: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/styles/Button.js